import React, { memo } from 'react';
import { ProgressCard as ProgressCardType } from './types';
import { DefaultProgressCard } from './DefaultProgressCard';
import { GenerateProgressCard } from './GenerateProgressCard';

interface ProgressCardProps {
  card: ProgressCardType;
  type?: 'TARGET' | 'GENERATE';
}

export const ProgressCard: React.FC<ProgressCardProps> = memo(({ card, type }) => {
  // Use the type prop if provided, otherwise fall back to card.type, default to 'TARGET'
  const cardType = type || card.type || 'TARGET';

  // Render DefaultProgressCard for 'TARGET' type or when no type is specified
  if (cardType === 'TARGET') {
    return <DefaultProgressCard card={card} />;
  }

  // Render GenerateProgressCard for 'GENERATE' type
  if (cardType === 'GENERATE') {
    return <GenerateProgressCard card={card} />;
  }

  // Fallback to DefaultProgressCard for any other case
  return <DefaultProgressCard card={card} />;
});

// Add display name for debugging
ProgressCard.displayName = 'ProgressCard';
